function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Setup strip (COMMERCE_ONBOARDING Phase 2) — the in-app "finish setup" invitation +
// progress, shown at the top of the Dashboard while onboarding is incomplete. Doubles as
// the nudge: dismiss hides it for a week (the spec's weekly-max cadence). Derived live via
// onboarding-status.js; ob- design system for visual consistency with /Setup.

import React from "react";
import { withRouter } from "react-router";
import account from "../../data/account";
import { getOnboardingStatus } from "../../functions/onboarding-status";
import { OB_CSS } from "./onboarding-css";
const WEEK = 7 * 24 * 60 * 60 * 1000;
const key = () => `plunk-setup-strip-dismissed:${(account.get() || {}).tenantId || "ws"}`;
const dismissedRecently = () => {
  try {
    const t = Number(localStorage.getItem(key()) || 0);
    return t && Date.now() - t < WEEK;
  } catch (e) {
    return false;
  }
};
class SetupStrip extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "dismiss", () => {
      try {
        localStorage.setItem(key(), String(Date.now()));
      } catch (e) {/* private */}
      this.setState({
        hidden: true
      });
    });
    this.state = {
      ob: null,
      hidden: dismissedRecently()
    };
    this._alive = true;
  }
  async componentDidMount() {
    if (this.state.hidden) return;
    const ob = await getOnboardingStatus().catch(() => null);
    if (this._alive) this.setState({
      ob
    });
  }
  componentWillUnmount() {
    this._alive = false;
  }
  render() {
    const {
      ob,
      hidden
    } = this.state;
    if (hidden || !ob || ob.done >= ob.total) return null; // only while genuinely incomplete
    const pct = Math.round(ob.done / Math.max(1, ob.total) * 100);
    const name = (account.get() || {}).account || "your workspace";
    const left = ob.total - ob.done;
    return /*#__PURE__*/React.createElement("div", {
      className: "ob-root",
      style: {
        padding: 0,
        margin: "0 0 14px"
      }
    }, /*#__PURE__*/React.createElement("style", null, OB_CSS), /*#__PURE__*/React.createElement("div", {
      className: "ob-strip",
      style: {
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 9,
        minWidth: 0
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      style: {
        color: "var(--ob-primary)",
        fontSize: 20
      }
    }, "rocket_launch"), /*#__PURE__*/React.createElement("b", null, "Finish setting up ", name)), /*#__PURE__*/React.createElement("span", {
      className: "ob-chips"
    }, /*#__PURE__*/React.createElement("span", null, ob.done, " of ", ob.total, " done")), /*#__PURE__*/React.createElement("div", {
      className: "ob-bar"
    }, /*#__PURE__*/React.createElement("i", {
      style: {
        width: `${pct}%`
      }
    })), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn sm",
      onClick: () => this.props.history.push("/Setup")
    }, left, " step", left === 1 ? "" : "s", " left: finish setup"), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn ghost sm",
      title: "Remind me later",
      onClick: this.dismiss
    }, "Later")));
  }
}
export default withRouter(SetupStrip);
export const SetupStrip_ = withRouter(SetupStrip);